import { render, staticRenderFns } from "./PrizeAlert.vue?vue&type=template&id=f7cbf6a4&scoped=true&"
import script from "./PrizeAlert.vue?vue&type=script&lang=js&"
export * from "./PrizeAlert.vue?vue&type=script&lang=js&"
import style0 from "./PrizeAlert.vue?vue&type=style&index=0&id=f7cbf6a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7cbf6a4",
  null
  
)

component.options.__file = "PrizeAlert.vue"
export default component.exports